import { render, staticRenderFns } from "./PostDocCp.vue?vue&type=template&id=e12abffa&scoped=true&"
import script from "./PostDocCp.vue?vue&type=script&lang=js&"
export * from "./PostDocCp.vue?vue&type=script&lang=js&"
import style0 from "./PostDocCp.vue?vue&type=style&index=0&id=e12abffa&prod&scoped=true&lang=css&"
import style1 from "./PostDocCp.vue?vue&type=style&index=1&id=e12abffa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12abffa",
  null
  
)

export default component.exports